import { BE_URLS } from "@/constants/config.js";
import axios from "@/api/axios/axios_core_deal.js";

const DEAL_HOST = BE_URLS.BACKEND_DEAL_SERVER_URL;

export function saveEmailProvider(data) {
  return axios.post(`${DEAL_HOST}/email-provider`, data);
}

export function getEmailProvider() {
  return axios.get(`${DEAL_HOST}/email-provider`);
}

export function testEmailProviderConnection() {
  return axios.post(`${DEAL_HOST}/email-provider/test-connection`);
}

export function deleteEmailProvider() {
  return axios.delete(`${DEAL_HOST}/email-provider`);
}
